import { section } from "@/glow";
import { qs } from "@fluorescent/dom";
import Carousel from "@/lib/carousel";
import getMediaQuery from "@/lib/media-queries";
import atBreakpointChange from "@/lib/at-breakpoint-change";
import { animateMultiColumn, shouldAnimate } from "@/lib/animation";

const selectors = {
  sliderContainer: ".carousel",
};

section("multi-column", {
  onLoad() {
    const { sliderOnMobile: sliderOnMobileString } = this.container.dataset;
    const sliderOnMobile = sliderOnMobileString === "true";

    if (
      sliderOnMobile &&
      window.matchMedia(getMediaQuery("below-720")).matches
    ) {
      this._initCarousel();
    }

    this.breakPointHandler = atBreakpointChange(720, () => {
      if (
        sliderOnMobile &&
        window.matchMedia(getMediaQuery("below-720")).matches
      ) {
        this._initCarousel();
      } else {
        this.carousel?.destroy();
      }
    });

    if (shouldAnimate(this.container)) {
      this.animateMultiColumn = animateMultiColumn(this.container);
    }
  },

  _initCarousel() {
    const { mobileColumnsPerView } = this.container.dataset;
    this.mobilePerView = parseInt(mobileColumnsPerView, 10) * 1.05; // Peek value
    this.carouselElement = qs(selectors.sliderContainer, this.container);

    this.carousel = Carousel(this.carouselElement, {
      slidesPerView: this.mobilePerView,
      spaceBetween: 12,
    });
  },

  onUnload() {
    this.breakPointHandler.unload();
    this.carousel?.destroy();
    this.animateMultiColumn?.destroy();
  },
});
